import React, { useMemo } from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { includes } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';
import VFText from '../../VFText';

import styles from './Item.Styles';

function Item({
  theme,
  id,
  name,
  selectedCategories,
  setSelectedCategories,
  textAccessibilityLabel,
  itemTextStyle,
}) {
  const _isItemSelected = useMemo(
    () => (!id && !selectedCategories.length) || (id && includes(selectedCategories, id)),
    [selectedCategories],
  );
  return (
    <TouchableOpacity
      onPress={() => setSelectedCategories(id)}
      accessibilityLabel={`${textAccessibilityLabel}Btn`}
      testID={`${textAccessibilityLabel}Btn` ?? FoundationTestKeys.filterBarItemTO}
    >
      <View
        style={[
          styles.itemContainer(theme),
          _isItemSelected ? styles.selectedItemContainer(theme) : null,
        ]}
        testID={FoundationTestKeys.filterBarItemTOView}
      >
        <VFText
          style={[styles.item, _isItemSelected ? styles.selectedItem(theme) : null, itemTextStyle]}
          i18nKey={name}
          accessibilityLabel={textAccessibilityLabel}
          testKey={textAccessibilityLabel ?? FoundationTestKeys.filterBarItemTOText}
        />
      </View>
    </TouchableOpacity>
  );
}

Item.defaultProps = {
  theme: LightThemeColors,
  withSeeAll: true,
};

Item.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withSeeAll: PropTypes.bool,
  id: PropTypes.number || PropTypes.string,
  name: PropTypes.string,
  index: PropTypes.number,
  selectedCategories: PropTypes.array,
  setSelectedCategories: PropTypes.func,
  textAccessibilityLabel: PropTypes.string,
  itemTextStyle: ViewPropTypes.style,
};

export default Item;
